import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/LinkIcon.svg';
const _hoisted_1 = { class: "test-page" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { getHttpInstance } from '@/composables/useApi';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MoneyHubCallbackPage',
    setup(__props) {
        const route = useRoute();
        const state = useAppState();
        useAuth();
        const done = ref(false);
        function completeLink() {
            getHttpInstance().get(state.api + "/moneyhub?code=" + route.params["code"])
                .then(() => {
                done.value = true;
                window.location.href = "/MG_POP.html";
            });
        }
        onMounted(() => {
            completeLink();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "centered" }, [
                    _createElementVNode("img", {
                        class: "pageHeaderIconBigger",
                        src: _imports_0
                    })
                ], -1)),
                _createElementVNode("div", _hoisted_1, [
                    _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Completing Account Link", -1)),
                    (!done.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "We are completing your connection now. Please wait . . ."))
                        : _createCommentVNode("", true),
                    (done.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "All done! taking you back to your Finances . . ."))
                        : _createCommentVNode("", true)
                ])
            ], 64));
        };
    }
});
